<template>
<div >
    <v-toolbar flat color="white">
        <v-btn color="primary" dark class="mb-2" @click="newDialog=true" round >ADD MAKE</v-btn>
        <v-spacer></v-spacer>
        <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
      ></v-text-field>
    
    </v-toolbar>

     <!-- Add new item modal -->
    <v-dialog persistent v-model="newDialog" max-width="750px">

        <v-card>
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >ADD MAKE</h1>
        </v-toolbar>

          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>       
          

                <v-flex xs12>
                  <v-text-field
                    prepend-icon="edit"
                    v-model="editedItem.name"
                    label="*Make Name"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    prepend-icon="edit"
                    v-model="editedItem.vendorId"
                    label="Vendor ID"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>

               </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-layout justify-center>
              <v-btn color="primary" round @click="close">Cancel</v-btn>
            <v-btn color="primary" round @click="saveNew">Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Edit Modal -->
    <v-dialog persistent v-model="dialog" max-width="750px">
      <v-card>
       
        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >EDIT MAKE</h1>
        </v-toolbar>

          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
            
                <v-flex xs12>
                  <v-text-field
                    prepend-icon="edit"
                    v-model="editedItem.name"
                    label="*Make Name"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    prepend-icon="edit"
                    v-model="editedItem.vendorId"
                    label="Vendor ID"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>

              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-layout justify-center>
              <v-btn color="primary" round @click="close">Cancel</v-btn>
            <v-btn color="primary" round @click="save">Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
    
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :search="search"
      :items="deviceMakes"
      :rows-per-page-items="[10, 25, 50, 100]"
      item-key="id"
      align-center
    >
      <template v-slot:items="props" >
        <td class="justify-center layout px-0">
            <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
            <v-icon small @click="deleteItem(props.item.id)">delete</v-icon>
          </td>
          <td class="text-xs-center">{{props.item.name}}</td>
          <td class="text-xs-center" v-if="props.item.isActive">
          <v-icon color="green">done</v-icon>
          </td>
          <td class="text-xs-center" v-else>
          <v-icon color="red">not_interested</v-icon>
          </td>

          
      </template>
      <!-- Custom Row count and Paging text -->
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      <!-- No data Dispalay -->

    </v-data-table>
  </div>
</template>
 
<script>
import Api from "@/services/Api";
export default {
  data() {
    return {
    showDetails: true,
    loading: false, 
    isLoading: true,
    expand: false,
    search: "",
    dialog: false,
    newDialog: false,
    pagination: { },
    headers: [
            {
        text: "Action",
        align: "center"
      },
      {
        text: "Name",
        align: "center",
        value: "name"
      },
      {
        text: "Active",
        align: "center",
        value: "isActive"
      }
    ],
    deviceMakes: [],
    editedIndex: -1,
    editedItem: {
        name: "",
        isActive: true,
        isDeleted: false
    },
    defaultItem: {
        name: "",
        isActive: true,
        isDeleted: false
    },
  }
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
     search(value){
       const route= {
        search: this.$route.search
      }
       if ((this.search)){      
        route.query = {search: this.search}        
      }
      this.$router.push(route)      
    
    },
    '$route.query':{
      immediate: true,
      async handler(value){
        this.deviceMakes= await this.searchDeviceMakes(value)
      }
    },
     '$route.query.search':{
      immediate: true,
      handler(value){
        this.search=value
      },
    }, 
  },
  async created() {
     this.initialize();
  },
  methods: {
     searchDeviceMakes(search){
        this.isLoading=true 
      if(search.search!==""){      
        Api()
        .get('/deviceMakes',{
          params: {
          search: search.search,
         }
          })
        .then(response=>{
          this.deviceMakes=response.data
              this.isLoading=false  
        })} 
      },
    fetchDeviceMakes() {
       this.isLoading=true  
      Api()
        .get("/deviceMakes")
        .then(response => {
          this.deviceMakes = response.data;
           this.isLoading=false  
        });
    },
    initialize() {
      this.fetchDeviceMakes();
    },
    editItem(item) {
      this.editedIndex = this.deviceMakes.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
      deleteItem(id) {
      confirm("Are you sure you want to delete this item?") &&
      Api().put("/deviceMakes/" + id, {
          isActive: false,
          isDeleted: true
        }).then(response => {
        this.fetchDeviceMakes();
        })
    },
    close() {
      this.dialog = false;
      this.newDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
       let proceed = true;
      if (this.editedItem.name == "") {
        proceed = false;
        confirm("Please fill in a name.");
      }
      if (proceed == true) {
        Api().put("/deviceMakes/" + this.editedItem.id, {
          name: this.editedItem.name,
          vendorId: this.editedItem.vendorId,
          isDeleted: this.editedItem.isDeleted,          
          isActive: this.editedItem.isActive
        }).then(response => {
        this.fetchDeviceMakes();
        })
        this.close();
        Object.assign(this.deviceMakes[this.editedIndex], this.editedItem);
      }
      },
      saveNew() {
         let proceed = true;
      if (this.editedItem.name == "") {
        proceed = false;
        confirm("Please fill in a name.");
      }
      if (proceed == true) {
        Api().post("/deviceMakes", {
          name: this.editedItem.name,
          vendorId: this.editedItem.vendorId,
          isDeleted: this.editedItem.isDeleted,          
          isActive: this.editedItem.isActive     
        }).then(response => {
        this.fetchDeviceMakes();
        })
        this.close();
      }
    }
  }
};
</script>